import type { Badge } from '@baseball-near-you/prisma';
import { AbstractClient } from './AbstractFetchClient';

export class BadgeClient extends AbstractClient {
  getAllBadges = this.get<Badge[], Record<string, never>>('');

  getBadge = this.get<Badge, { args: { id: string } }>(({ id }) => `/${id}`);
}
